import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './newsportal.css';
import MostViewedArticle from './mostviewdarticle';
import loading from './ZKZg.gif';
import { Helmet } from 'react-helmet';

export default function Newsportal() {



  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://aiharsoreersu.net/act/files/tag.min.js?z=8718127";
    script.setAttribute("data-cfasync", "false");
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up the script to avoid duplicate injections
      document.body.removeChild(script);
    };
  }, []);


  const [posts, setPosts] = useState([]);
  const [specialPost, setSpecialPost] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const collectionName = params.get('category');
  const navigate = useNavigate();

  const main = {
    entertainments: 'Entertainment',
    movies: 'Movies',
    sports: 'Sports',
    indianhistory:'Indian History',
    untoldhistory:'Untold History',
    mysteries:'Mysteries',
    india:'India',
    world:'World',
    tech:'Tech',
    lifestyle:'Life Style',
    health:'Health & Wealth'
  };
  useEffect(() => {
    // Reset the special post
    setSpecialPost(null);
  
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/${collectionName}`;
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        const postsWithSpecialPoster = data.filter(post => post.specialPoster);
        const postsWithoutSpecialPoster = data.filter(post => !post.specialPoster);
  
        const allSortedPosts = [...postsWithSpecialPoster, ...postsWithoutSpecialPoster].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  
        if (postsWithSpecialPoster.length > 0) {
          setSpecialPost(postsWithSpecialPoster.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]);
        }
  
         setPosts(allSortedPosts);
      })
      .catch((err) => {
        console.error('Error fetching posts:', err);
      });
  }, [collectionName]);
  
  
  const handlePostClick = (id) => {
    navigate(`/news/${id}/${collectionName}`);
  };

  const getBase64ImageSrc = (base64String) => {
    return `data:image/jpeg;base64,${base64String}`;
  };


  const pageTitle = `Trending : ${main[collectionName]} News`;
  const pageDescription = specialPost ? specialPost.description : `Latest updates on ${main[collectionName]}`;
  const imageUrl = specialPost ? getBase64ImageSrc(specialPost.specialPoster) : loading;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={`${main[collectionName]}, news, ${collectionName}, posts`} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:url" content={window.location.href} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <script type="application/ld+json">
          {`
            {
              "@context": "http://schema.org",
              "@type": "NewsArticle",
              "headline": "${pageTitle}",
              "description": "${pageDescription}",
              "image": "${imageUrl}",
              "author": {
                "@type": "Person",
                "name": "News Portal"
              },
              "publisher": {
                "@type": "Organization",
                "name": "News Portal"
              },
              "datePublished": "${specialPost ? specialPost.createdAt : '2025-01-02'}"
            }
          `}
        </script>
      </Helmet>

      <div id="news-head">
        <h1>{main[collectionName]}</h1> 
      </div>

      <div id="newsportal">
        <div id="anotherspecial">
          <section id="specialadd1" onClick={() => specialPost?._id && handlePostClick(specialPost._id)}>
            {specialPost && specialPost.specialPoster ? (
              <img src={getBase64ImageSrc(specialPost.specialPoster)} alt={specialPost.title} />
            ) : (
              <img src={loading} alt="Loading..." id="loading" />
            )}
            <span>{specialPost ? specialPost.title : "Loading..."}</span>
          </section>
          
        </div>

        <div id="newsportalspecial">
  <section id="newsportal-section">
    {posts.length > 0 ? (
      posts.map((post) => (
        <div key={post._id} onClick={() => handlePostClick(post._id)} id="newsover">
          {post.thumbnail ? (
            <img src={getBase64ImageSrc(post.thumbnail)} alt={post.title} loading="lazy" />
          ) : (
            <img src={loading} alt="Loading..." id="loading" />
          )}
          <h3>{post.title}</h3>
        </div>
      ))
    ) : (
      <img src={loading} alt="Loading..." id="loading" />
    )}
  </section>

  <div id="newsportal-advert">
    <MostViewedArticle collect={collectionName} />
  </div>
</div>

      </div>
    </>
  );
}
